import { NgClass } from '@angular/common';
import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
    output,
    ViewEncapsulation,
} from '@angular/core';
import { DEALER_THEME } from '@hyundai/shared-lib';

let errorId = 0;

@Component({
    selector: 'ui-input-wrapper',
    templateUrl: './input-wrapper.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass],
})
export class InputWrapperComponent {
    label = input<string>();
    disabled = input(false, { transform: booleanAttribute });
    error = input(false, { transform: booleanAttribute });
    errorMsg = input<string>();
    focussed = input(false);
    value = input<string | undefined>();
    placeholder = input<string>();
    inputId = input<string>();
    wrapValue = input(false, { transform: booleanAttribute });

    errorId = `errorId-${errorId++}`;

    valueOrPlaceholder = computed(() => {
        return this.value() ?? this.placeholder();
    });

    theme = input<DEALER_THEME>('light');
    clicked = output();
}
